import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Checkbox } from "antd";
import assets from "../../../../utils/ImagesPath";
import { displayMessage, postAPI } from "../../../../utils/common";
import {
  ERROR_MSG_TYPE,
  SUCCESS_MESSAGE,
} from "../../../../constants/messages";
import LS_SERVICE from "../../../../utils/localStorage";
import {
  REGISTER,
  LOGIN,
  SENT_OTP,
  VERIFY_OTP,
} from "../../../../constants/api";

const LoginModal = ({ isModalVisible, setIsModalVisible, setIsLoggedIn }) => {
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false); // New state to toggle forgot password form
  const [isOTPVerified, setIsOTPVerified] = useState(false); // New state to handle OTP verification
  const { company_name, company_description } = LS_SERVICE.get("setting") || {};
  const [bgIndex, setBgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prevIndex) => (prevIndex + 1) % 5);
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  // Handle login form submission
  const onFinishLogin = (values) => {
    setLoading(true);
    const data = new FormData();
    data.append("email", values.username);
    data.append("password", values.password);
    data.append("user_type", "customer");
    const successFn = function (data) {
      if (data["status"] === true) {
        if (data["user"]["user_type"] === "customer") {
          LS_SERVICE.set("id", data["user"]["id"]);
          LS_SERVICE.set("name", data["user"]["name"]);
          LS_SERVICE.set("user_type", data["user"]["user_type"]);
          LS_SERVICE.set("phone", data["user"]["phone"]);
          LS_SERVICE.set("email", data["user"]["email"]);
          LS_SERVICE.set("token", data["token"]);
          LS_SERVICE.set("isCustomer", true);
          setLoading(false);
          setIsLoggedIn(true);
          setIsModalVisible(false);
          displayMessage(SUCCESS_MESSAGE, data["message"]);
          window.location.reload();
        } else {
          displayMessage(ERROR_MSG_TYPE, "You are not a customer");
          setLoading(false);
          setIsLoggedIn(false);
        }
      } else {
        setLoading(false);
        setIsLoggedIn(false);
        // setIsModalVisible(false);
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      setLoading(false);
      setIsLoggedIn(false);
      setIsModalVisible(false);
      displayMessage(ERROR_MSG_TYPE, "Fail to Login");
    };
    postAPI(LOGIN, data, successFn, errorFn);
  };

  // Handle signup form submission
  const onFinishSignup = (values) => {
    setLoading(true);
    const data = new FormData();
    data.append("name", values.name);
    data.append("email", values.email);
    data.append("phone", values.phone);
    data.append("password", values.password);
    data.append("user_type", "customer");
    const successFn = function (data) {
      if (data["status"] === true) {
        setLoading(false);
        setIsSignup(false);
        displayMessage(SUCCESS_MESSAGE, data["message"]);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Fail to Login");
    };
    postAPI(REGISTER, data, successFn, errorFn);
  };

  // Handle forgot password email submission
  const onFinishForgotPassword = (values) => {
    setLoading(true);
    const data = new FormData();
    data.append("mobileNo", values.mobileNo);
    const successFn = function (data) {
      if (data["status"] === true) {
        setIsOTPVerified(true); // Show OTP verification form
        setIsForgotPassword(false);
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data["message"]);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Failed to send OTP.");
    };
    postAPI(SENT_OTP, data, successFn, errorFn);
  };

  // Handle OTP verification
  const onFinishOTP = (values) => {
    setLoading(true);
    const data = new FormData();
    data.append("mobileNo", values.mobileNo);
    data.append("otp", values.otp);
    const successFn = function (data) {
      if (data["status"] === true) {
        setLoading(false);
        setIsOTPVerified(false);
        setIsForgotPassword(false);
        setIsSignup(false);
        displayMessage(SUCCESS_MESSAGE, data["message"]);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"]);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "OTP verification failed.");
    };
    postAPI(VERIFY_OTP, data, successFn, errorFn);
  };

  // Toggle between login and signup forms
  const handleSignupClick = () => {
    setIsSignup(true);
  };

  const handleLoginClick = () => {
    setIsSignup(false);
    setIsOTPVerified(false);
    setIsForgotPassword(false);
  };

  const handleForgotPasswordClick = () => {
    setIsForgotPassword(true); // Show forgot password form
  };

  return (
    <Modal
      title={null}
      open={isModalVisible}
      onCancel={() => {
        setLoading(false);
        handleLoginClick();
        setIsModalVisible(false);
      }}
      footer={null}
      width={800}
      centered
      closable={true}
      destroyOnClose={true}
      className="custom-login-modal"
    >
      <div className="login-modal-content">
        {/* LEFT: Login, Signup, Forgot Password or OTP Form */}
        <div className="login-left">
          {isForgotPassword ? (
            <div>
              <h2>Forgot Password</h2>
              <p>Please enter your mobile number.</p>
              <Form
                name="forgot-password"
                onFinish={onFinishForgotPassword}
                layout="vertical"
                className="login-form"
              >
                <Form.Item
                  name="mobileNo"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your mobile number!",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit mobile number!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your mobile number" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Submit
                  </Button>
                </Form.Item>

                <p className="signup-link">
                  Remembered your password?{" "}
                  <a onClick={handleLoginClick}>Login</a>
                </p>
              </Form>
            </div>
          ) : isOTPVerified ? (
            <div>
              <h2>Verify OTP</h2>
              <p>Please enter the OTP sent to your email.</p>
              <Form
                name="otp-verify"
                onFinish={onFinishOTP}
                layout="vertical"
                className="login-form"
              >
                <Form.Item
                  name="mobileNo"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your mobile number!",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit mobile number!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your mobile number" />
                </Form.Item>

                <Form.Item
                  label="Enter OTP"
                  name="otp"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the 4-digit OTP!",
                    },
                  ]}
                >
                  <Input autoFocus />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Verify OTP
                  </Button>
                </Form.Item>
              </Form>
            </div>
          ) : isSignup ? (
            <div>
              <h2>Create a new account</h2>
              <p>Please enter your details to sign up.</p>
              <Form
                name="signup"
                onFinish={onFinishSignup}
                layout="vertical"
                className="login-form"
              >
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name!" },
                  ]}
                >
                  <Input placeholder="Enter your name" />
                </Form.Item>

                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                    { type: "email", message: "Please enter a valid email!" },
                  ]}
                >
                  <Input placeholder="Enter your email" />
                </Form.Item>

                <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your phone number!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your phone" />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Sign Up
                  </Button>
                </Form.Item>

                <p className="signup-link">
                  Already have an account?{" "}
                  <a onClick={handleLoginClick}>Login</a>
                </p>
              </Form>
            </div>
          ) : (
            <div>
              <h2>Welcome back</h2>
              <p>Please enter your details.</p>
              <Form
                name="login"
                onFinish={onFinishLogin}
                layout="vertical"
                className="login-form"
              >
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your mobile number!",
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit mobile number!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your mobile number" />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                  ]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>

                <div className="login-options">
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox>Send me exclusive deals </Checkbox>
                  </Form.Item>
                  <a
                    className="forgot-link"
                    onClick={handleForgotPasswordClick}
                  >
                    Forgot password
                  </a>
                </div>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Sign in
                  </Button>
                </Form.Item>

                <p className="signup-link">
                  Don’t have an account?{" "}
                  <a onClick={handleSignupClick}>Sign up for free</a>
                </p>
              </Form>
            </div>
          )}
        </div>

        {/* RIGHT: Testimonial Image & Text */}
        <div
          className="login-right"
          style={{
            background: `url(${assets.backgrounds[bgIndex]}) no-repeat center center`,
            backgroundSize: "cover",
          }}
        >
          <div className="testimonial">
            <p className="quote">
              Discover and book your perfect stay — from cozy boutique hotels to
              luxury resorts — all in one place.
            </p>
            <p className="author">Welcome to {company_name}</p>
            <p className="meta">{company_description}</p>
            <div className="stars">🏨 ✈️ 🌍</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
